/**
 * Exportação CSV no navegador (Fase 6, item 22).
 *
 * Formato pensado para abrir direto no Excel em pt-BR: BOM UTF-8 (senão acentos viram
 * lixo), separador `;` (a vírgula é o decimal aqui) e toda célula entre aspas com aspas
 * internas dobradas. Exporta o que a tela já carregou — sem nova chamada ao backend, e
 * portanto exatamente o que o usuário está vendo, no escopo dele.
 */

export type CelulaCsv = string | number | boolean | null | undefined

const escapar = (valor: CelulaCsv): string => {
  const texto = valor == null ? '' : String(valor)
  return `"${texto.replace(/"/g, '""')}"`
}

/** Monta o conteúdo do CSV (exportado separado para ser testável sem DOM). */
export const montarCsv = (cabecalho: string[], linhas: CelulaCsv[][]): string => {
  const corpo = [cabecalho, ...linhas].map((l) => l.map(escapar).join(';')).join('\r\n')
  return `﻿${corpo}`
}

/** Dispara o download. Nome sem extensão recebe `.csv`. */
export const baixarCsv = (nomeArquivo: string, cabecalho: string[], linhas: CelulaCsv[][]): void => {
  const nome = nomeArquivo.toLowerCase().endsWith('.csv') ? nomeArquivo : `${nomeArquivo}.csv`
  const blob = new Blob([montarCsv(cabecalho, linhas)], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = nome
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/** Data de hoje como sufixo de arquivo: 2026-08-18. */
export const sufixoData = (): string => new Date().toISOString().slice(0, 10)
